<template>
    <div class="field field--select" :class="fieldClasses">
        <div class="row collapse no-pad align-middle" v-if="helptext || label">
            <div class="columns shrink" v-if="helptext">
                <help-text :helptext="helptext"></help-text>
            </div>
            <div class="columns" v-if="label">
              <label :class="labelClasses">{{ label }}</label>
            </div>
        </div>
        <div class="row">
            <div class="columns">
                <select @change="updateValue" :value="value">
                    <option value="">
                        {{ initialText }}
                    </option>
                    <option :value="option.abbreviation" v-for="option in stateOptions">
                        {{ option.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row" v-if="hasErrors">
            <div class="columns">
                <ul class="field__errors">
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Component Dependencies
     */
    import SelectBase from './SelectField'
    import HelpText from '../HelpText'
    import { stateOptions } from '../../../services/UtilityService'

    /**
     * Component
     */
    export default {
        name: 'state_select_field',
        extends: SelectBase,
        components: {
            HelpText
        },
        data () {
            return {
                stateOptions: stateOptions
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/forms/StateSelectField.vue